export default __webpack_public_path__ + "static/media/discord.28c4cf00.png";